import {
  GET_BUSINESS_UNITS,
  GET_BUSINESS_UNITS_SUCCESS,
  GET_BUSINESS_UNITS_FAIL,
  SHOW_DELETE_MODAL,
  HIDE_DELETE_MODAL,
  DELETE_BUSINESS_UNIT,
  DELETE_BUSINESS_UNIT_SUCCESS,
  DELETE_BUSINESS_UNIT_FAIL,
  CREATE_BUSINESS_UNIT,
  CREATE_BUSINESS_UNIT_SUCCESS,
  CREATE_BUSINESS_UNIT_FAIL,
  UPDATE_BUSINESS_UNIT,
  UPDATE_BUSINESS_UNIT_SUCCESS,
  UPDATE_BUSINESS_UNIT_FAIL,
  GET_BUSINESS_UNIT,
  GET_BUSINESS_UNIT_SUCCESS,
  GET_BUSINESS_UNIT_FAIL,
} from "store/businessUnits/actionTypes"

export const getBusinessUnits = params => ({
  type: GET_BUSINESS_UNITS,
  payload: { params },
})

export const getBusinessUnitsSuccess = values => ({
  type: GET_BUSINESS_UNITS_SUCCESS,
  payload: values,
})

export const getBusinessUnitsFail = error => ({
  type: GET_BUSINESS_UNITS_FAIL,
  payload: error,
})

export const getBusinessUnit = params => ({
  type: GET_BUSINESS_UNIT,
  payload: { params },
})

export const getBusinessUnitSuccess = values => ({
  type: GET_BUSINESS_UNIT_SUCCESS,
  payload: values,
})

export const getBusinessUnitFail = error => ({
  type: GET_BUSINESS_UNIT_FAIL,
  payload: error,
})

export const showDeleteModal = () => ({
  type: SHOW_DELETE_MODAL,
  payload: {},
})

export const hideDeleteModal = () => ({
  type: HIDE_DELETE_MODAL,
  payload: {},
})

export const deleteBusinessUnit = params => ({
  type: DELETE_BUSINESS_UNIT,
  payload: { params },
})

export const deleteBusinessUnitSuccess = () => ({
  type: DELETE_BUSINESS_UNIT_SUCCESS,
})

export const deleteBusinessUnitFail = error => ({
  type: DELETE_BUSINESS_UNIT_FAIL,
  payload: error,
})

export const createBusinessUnit = params => ({
  type: CREATE_BUSINESS_UNIT,
  payload: params,
})

export const createBusinessUnitSuccess = () => ({
  type: CREATE_BUSINESS_UNIT_SUCCESS,
})

export const createBusinessUnitFail = error => ({
  type: CREATE_BUSINESS_UNIT_FAIL,
  payload: error,
})

export const updateBusinessUnit = params => ({
  type: UPDATE_BUSINESS_UNIT,
  payload: params,
})

export const updateBusinessUnitSuccess = () => ({
  type: UPDATE_BUSINESS_UNIT_SUCCESS,
})

export const updateBusinessUnitFail = error => ({
  type: UPDATE_BUSINESS_UNIT_FAIL,
  payload: error,
})

export const resetBusinessUnits = () => ({
  type: GET_BUSINESS_UNITS_SUCCESS,
  payload: [],
})
